import { COLUMN_DEFINITIONS } from './constants'
import type { ColumnDefinitionKeys, CsvColumnNames, CsvRow, RowValidated } from './types'

/**
 * Sanitizes rows by
 *   1. lowercasing and trimming keys;
 *   2. validating required fields.
 */
export const sanitizeRows = (rows: CsvRow[]) => {
  let nInvalidRows = 0
  const sanitizedRows: RowValidated[] = []

  rows.forEach((row) => {
    const trimmedRow = Object.keys(row).reduce<CsvRow>((acc, x) => {
      return {
        ...acc,
        [x.trim()]: row[x as CsvColumnNames],
      }
    }, {})

    const sanitized: RowValidated = {
      [COLUMN_DEFINITIONS.applicantName.csvColumnName]:
        trimmedRow[COLUMN_DEFINITIONS.applicantName.csvColumnName]?.toString(),
      [COLUMN_DEFINITIONS.applicantEmail.csvColumnName]:
        trimmedRow[COLUMN_DEFINITIONS.applicantEmail.csvColumnName]?.toString(),
      [COLUMN_DEFINITIONS.applicantPhone.csvColumnName]:
        trimmedRow[COLUMN_DEFINITIONS.applicantPhone.csvColumnName]?.toString(),
      [COLUMN_DEFINITIONS.applicantTags.csvColumnName]:
        trimmedRow[COLUMN_DEFINITIONS.applicantTags.csvColumnName]?.toString(),
      [COLUMN_DEFINITIONS.category.csvColumnName]: trimmedRow[COLUMN_DEFINITIONS.category.csvColumnName]?.toString(),
      [COLUMN_DEFINITIONS.caseNumber.csvColumnName]:
        trimmedRow[COLUMN_DEFINITIONS.caseNumber.csvColumnName]?.toString(),
      [COLUMN_DEFINITIONS.caseTags.csvColumnName]: trimmedRow[COLUMN_DEFINITIONS.caseTags.csvColumnName]?.toString(),
    }

    const isValid = validateRow(trimmedRow)

    if (!isValid) {
      nInvalidRows++
      sanitized.hasError = true
    }

    sanitizedRows.push(sanitized)
  })

  return {
    nInvalidRows,
    sanitizedRows,
  }
}

export const validateRow = (row: CsvRow) => {
  const columnDefinitionKeys = Object.keys(COLUMN_DEFINITIONS) as ColumnDefinitionKeys[]
  const requiredColumnDefinitionKeys = columnDefinitionKeys.filter((k) => COLUMN_DEFINITIONS[k].required)
  const requiredColumnKeys = requiredColumnDefinitionKeys.map((k) => COLUMN_DEFINITIONS[k].csvColumnName)
  const isValid = requiredColumnKeys.every((k) => !!row[k])

  return isValid
}

/**
 * Given a string of tags, produces an array of tags.
 */
export const prepareTags = (tags: string) => {
  const split = tags.split(/\s*,\s*/) ?? []
  const trimmed = split.map((x) => x.trim())
  const filtered = trimmed.filter((x) => x.length > 0)

  return [...new Set(filtered)]
}
